
const emojiRegex = function () {
  return /\uD83C(?:\uDDE6\uD83C(?:\uDDEB|\uDDFD|\uDDF1|\uDDF8|\uDDE9|\uDDF4|\uDDEE|\uDDF6|\uDDEC|\uDDF7|\uDDF2|\uDDFC|\uDDE8|\uDDFA|\uDDF9|\uDDFF|\uDDEA)|\uDDE9\uD83C(?:\uDDFF|\uDDF0|\uDDEC|\uDDEF|\uDDF2|\uDDF4|\uDDEA)|\uDDE7\uD83C(?:\uDDF8|\uDDED|\uDDE9|\uDDE7|\uDDFE|\uDDEA|\uDDFF|\uDDEF|\uDDF2|\uDDF9|\uDDF4|\uDDE6|\uDDFC|\uDDFB|\uDDF7|\uDDF3|\uDDEC|\uDDEB|\uDDEE|\uDDF6|\uDDF1)|\uDDEE\uD83C(?:\uDDF4|\uDDE8|\uDDF8|\uDDF3|\uDDE9|\uDDF7|\uDDF6|\uDDEA|\uDDF2|\uDDF1|\uDDF9)|\uDDFB\uD83C(?:\uDDEC|\uDDE8|\uDDEE|\uDDFA|\uDDE6|\uDDEA|\uDDF3)|\uDDF0\uD83C(?:\uDDED|\uDDFE|\uDDF2|\uDDFF|\uDDEA|\uDDEE|\uDDFC|\uDDEC|\uDDF5|\uDDF7|\uDDF3)|\uDDE8\uD83C(?:\uDDF2|\uDDE6|\uDDFB|\uDDEB|\uDDF1|\uDDF3|\uDDFD|\uDDF5|\uDDE8|\uDDF4|\uDDEC|\uDDE9|\uDDF0|\uDDF7|\uDDEE|\uDDFA|\uDDFC|\uDDFE|\uDDFF|\uDDED)|\uDDEA\uD83C(?:\uDDE6|\uDDE8|\uDDEC|\uDDF7|\uDDEA|\uDDF9|\uDDFA|\uDDF8|\uDDED)|\uDDF9\uD83C(?:\uDDE9|\uDDEB|\uDDFC|\uDDEF|\uDDFF|\uDDED|\uDDF1|\uDDEC|\uDDF0|\uDDF4|\uDDF9|\uDDE6|\uDDF3|\uDDF7|\uDDF2|\uDDE8|\uDDFB)|\uDDED\uD83C(?:\uDDF7|\uDDF9|\uDDF2|\uDDF3|\uDDF0|\uDDFA)|\uDDF8\uD83C(?:\uDDFB|\uDDF2|\uDDF9|\uDDE6|\uDDF3|\uDDE8|\uDDF1|\uDDEC|\uDDFD|\uDDF0|\uDDEE|\uDDE7|\uDDF4|\uDDF8|\uDDED|\uDDE9|\uDDF7|\uDDEF|\uDDFF|\uDDEA|\uDDFE)|\uDDEC\uD83C(?:\uDDF6|\uDDEB|\uDDE6|\uDDF2|\uDDEA|\uDDED|\uDDEE|\uDDF7|\uDDF1|\uDDE9|\uDDF5|\uDDFA|\uDDF9|\uDDEC|\uDDF3|\uDDFC|\uDDFE|\uDDF8|\uDDE7)|\uDDEB\uD83C(?:\uDDF0|\uDDF4|\uDDEF|\uDDEE|\uDDF7|\uDDF2)|\uDDF5\uD83C(?:\uDDEB|\uDDF0|\uDDFC|\uDDF8|\uDDE6|\uDDEC|\uDDFE|\uDDEA|\uDDED|\uDDF3|\uDDF1|\uDDF9|\uDDF7|\uDDF2)|\uDDEF\uD83C(?:\uDDF2|\uDDF5|\uDDEA|\uDDF4)|\uDDFD\uD83C\uDDF0|\uDDF1\uD83C(?:\uDDE6|\uDDFB|\uDDE7|\uDDF8|\uDDF7|\uDDFE|\uDDEE|\uDDF9|\uDDFA|\uDDF0|\uDDE8)|\uDDF2\uD83C(?:\uDDF4|\uDDF0|\uDDEC|\uDDFC|\uDDFE|\uDDFB|\uDDF1|\uDDF9|\uDDED|\uDDF6|\uDDF7|\uDDFA|\uDDFD|\uDDE9|\uDDE8|\uDDF3|\uDDEA|\uDDF8|\uDDE6|\uDDFF|\uDDF2|\uDDF5|\uDDEB)|\uDDFE\uD83C(?:\uDDF9|\uDDEA)|\uDDF3\uD83C(?:\uDDE6|\uDDF7|\uDDF5|\uDDF1|\uDDE8|\uDDFF|\uDDEE|\uDDEA|\uDDEC|\uDDFA|\uDDEB|\uDDF4)|\uDDF4\uD83C\uDDF2|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C(?:\uDDEA|\uDDF4|\uDDFA|\uDDFC|\uDDF8)|\uDDFC\uD83C(?:\uDDF8|\uDDEB)|\uDDFF\uD83C(?:\uDDE6|\uDDF2|\uDDFC)|\uDDFA\uD83C(?:\uDDEC|\uDDE6|\uDDF8|\uDDFE|\uDDF2|\uDDFF))|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD95\uDD96\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0\uDEEB\uDEEC]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]/g;
}

/**
 * 检查字符串是否包含表情符
 * @param {string} str 被检测字符串
 */
const hasEmoji = (str) => {
  let i;
  if (typeof str === 'string') {
    for (i = 0; i < str.length; i++) {
      if (emojiRegex().test(str[i] + str[i + 1])) {
        return true;
      }
    }
  } else {
    return false;
  }
  return false;
};
/**
 * 上传的文件大小是否合法 不能超过3m
 * @param {size} number 文件大小
 */
const isFileSizeValid = ({ size }) => {
  if (size >= 3145728) {
    wx.showToast({
      title: '图片必须小于3MB',
      icon: 'none',
      duration: 3000,
    });
    return false;
  }
  return true;
};

const fileCompress = (cmp, canvasId, photoPath) => {
  return new Promise((reslove, reject) => {
    wx.getImageInfo({
      src: photoPath,
      success(res) {
        const { width, height } = res;
        cmp.setData(
          {
            canvasWidth: width,
            canvasHeight: height,
          },
          () => {
            const ctx = wx.createCanvasContext(canvasId, cmp);
            const quality = 0.92;
            ctx.drawImage(photoPath, 0, 0, width, height);
            ctx.draw(false, () => {
              wx.canvasToTempFilePath(
                {
                  canvasId,
                  width,
                  height,
                  destWidth: width,
                  destHeight: height,
                  quality,
                  success(fileInfo) {
                    const { tempFilePath } = fileInfo;
                    wx.getFileInfo({
                      filePath: tempFilePath,
                      success({ size }) {
                        // check文件大小是否合法
                        if (isFileSizeValid({ size })) {
                          reslove({
                            size,
                            tempFilePath,
                          });
                        } else {
                          reject();
                        }
                      },
                      fail() {
                        reject();
                      },
                    });
                  },
                  fail() {
                    reject();
                  },
                },
                cmp
              );
            });
          }
        );
      },
    });
  });
};

const isNetWork = () => {
  return new Promise((reslove, reject) => {
    wx.getNetworkType({
      success(res) {
        const networkType = res.networkType;
        if (networkType === 'none') {
          wx.showToast({
            title: '网络异常，请稍后再试',
            icon: 'none',
            duration: 3000,
          });
          reject();
        } else {
          reslove(networkType);
        }
      },
      fail() {
        wx.showToast({
          title: '网络异常，请稍后再试',
          icon: 'none',
          duration: 3000,
        });
        reject();
      },
    });
  });
};

const compareSDKVersion = (v1, v2) => {
  v1 = v1.split('.');
  v2 = v2.split('.');
  const len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }

  return 0;
};

const IM_PAGE = [
  'subpackages/consult/privateIm/privateIm',
];

// 当前页面是否是IM页面
const isImPage = () => {
  const pages = getCurrentPages(),
    currentPage = pages[pages.length - 1];
  return IM_PAGE.indexOf(currentPage.route) >= 0;
};

const keepOnlyOneIm = () => {
  return new Promise((resolve, reject) => {
    const currentPages = getCurrentPages();
    const len = currentPages.length,
      curPage = currentPages[len - 1];
    let i = 0,
      firstIm = null;
    while (i < len - 1) {
      if (IM_PAGE.find((page) => page === currentPages[i].route)) {
        firstIm = currentPages[i];
        break;
      }
      i++;
    }
    if (firstIm) {
      const backStep = len - (i + 1);
      const historyPage = currentPages[i];
      const historyOptions = historyPage.options;
      const { route, options } = curPage;
      if (
        options.doctorId === historyOptions.doctorId &&
        !options.hasOwnProperty('requestId')
      ) {
        wx.navigateBack({
          delta: backStep,
          complete: () => {
            resolve({ newPage: false, isReplace: true });
          },
        });
        return;
      }

      wx.navigateBack({
        delta: backStep,
        complete: () => {
          let param = [];
          Object.keys(options).forEach((key) => {
            param.push(`${key}=${options[key]}`);
          });
          wx.showLoading({
            mask: true,
          });
          const redirectToCurPage = () => {
            wx.redirectTo({
              url: `/${route}?${param.join('&')}`,
              success: function () {
                wx.showLoading({
                  mask: true,
                });
              },
              fail: (err) => {
                console.error(err);
                setTimeout(redirectToCurPage, 30);
              },
            });
          };
          redirectToCurPage();
          resolve({ newPage: true });
        },
      });
    } else {
      resolve({ newPage: true });
    }
  });
};
// 用户是否有相关权限
const isUserHasRight = (rightType) => {
  return new Promise((reslove, reject) => {
    wx.getSetting({
      success: function (res) {
        if (res && res.authSetting[rightType]) {
          reslove();
        } else {
          reject();
        }
      },
      fail: function () {
        reject();
      },
    });
  });
};
/**
 * 获取用户经纬度 由于wx.getLocation在用户有授权的情况下存在无回调的case 所以这里通过settimeout暂时绕过
 * https://developers.weixin.qq.com/community/develop/doc/000c240e1508d89911a8ff62556000?highLine=wx.getLocation%2520%25E6%2597%25A0%25E5%259B%259E%25E8%25B0%2583
 */
const saveUserLocation = () => {
  const saveLocationToGlobal = (res) => {
    const { latitude, longitude } = res;
    getApp().globalData.location = {
      latitude,
      longitude,
    };
  };
  return new Promise((reslove, reject) => {
    isUserHasRight('scope.userLocation')
      .then(() => {
        let hasComplete = false;
        setTimeout(() => {
          if (!hasComplete) {
            hasComplete = true;
            reslove();
          }
        }, 3000);
        // 获取经纬度
        wx.getLocation({
          success(res) {
            saveLocationToGlobal(res);
          },
          complete() {
            if (!hasComplete) {
              hasComplete = true;
              reslove();
            }
          },
        });
      })
      .catch(() => {
        // 首次授权获取经纬度
        wx.getLocation({
          success(res) {
            saveLocationToGlobal(res);
          },
          complete() {
            reslove();
          },
        });
      });
  });
};
/**
 * 是否为iphone全面屏手机
 */
const isIphoneFullScreen = () => {
  const {
    model,
    platform,
    system,
    windowHeight,
    safeArea,
  } = wx.getSystemInfoSync();
  // saveArea从基础库2.7版本开始支持
  if (
    system.toLocaleLowerCase().indexOf('ios') >= 0 &&
    safeArea &&
    safeArea.bottom !== windowHeight
  ) {
    return true;
  }
  // 老版本直接判断iphone X
  if (model.indexOf('iPhone X') >= 0 && platform !== 'devtools') {
    return true;
  }
  return false;
};

/**
 * 过滤企业微信消息 不在小程序端展示
 * @param {*} msgList
 */
const filterWxMessage = (msg) => {
  let { feature } = msg;

  if (typeof feature === 'string') {
    try {
      feature = JSON.parse(feature);
    } catch (e) {
      return false;
    }
  }

  if (feature && feature.channel === 'wx-proxy') {
    return false;
  }

  return true;
};

const BottomSaveAreaHeight = 30;

/**
 * jsonparse 处理消息id溢出
 */
const json_parse = (function () {
  'use strict';

  // This is a function that can parse a JSON text, producing a JavaScript
  // data structure. It is a simple, recursive descent parser. It does not use
  // eval or regular expressions, so it can be used as a model for implementing
  // a JSON parser in other languages.

  // We are defining the function inside of another function to avoid creating
  // global variables.

  var at,
    // The index of the current character
    ch,
    // The current character
    escapee = {
      '"': '"',
      '\\': '\\',
      '/': '/',
      b: '\b',
      f: '\f',
      n: '\n',
      r: '\r',
      t: '\t',
    },
    text,
    error = function error(m) {
      // Call error when something is wrong.

      throw {
        name: 'SyntaxError',
        message: m,
        at: at,
        text: text,
      };
    },
    next = function next(c) {
      // If a c parameter is provided, verify that it matches the current character.

      if (c && c !== ch) {
        error("Expected '" + c + "' instead of '" + ch + "'");
      }

      // Get the next character. When there are no more characters,
      // return the empty string.

      ch = text.charAt(at);
      at += 1;
      return ch;
    },
    number = function number() {
      // Parse a number value.

      var number,
        string = '';

      if (ch === '-') {
        string = '-';
        next('-');
      }
      while (ch >= '0' && ch <= '9') {
        string += ch;
        next();
      }
      if (ch === '.') {
        string += '.';
        while (next() && ch >= '0' && ch <= '9') {
          string += ch;
        }
      }
      if (ch === 'e' || ch === 'E') {
        string += ch;
        next();
        if (ch === '-' || ch === '+') {
          string += ch;
          next();
        }
        while (ch >= '0' && ch <= '9') {
          string += ch;
          next();
        }
      }
      // number = +string;

      if (string.length < 17) {
        number = +string;
      } else {
        number = string;
      }

      if (!isFinite(number)) {
        error('Bad number');
      } else {
        return number;
      }
    },
    string = function string() {
      // Parse a string value.

      var hex,
        i,
        string = '',
        uffff;

      // When parsing for string values, we must look for " and \ characters.

      if (ch === '"') {
        while (next()) {
          if (ch === '"') {
            next();
            return string;
          }
          if (ch === '\\') {
            next();
            if (ch === 'u') {
              uffff = 0;
              for (i = 0; i < 4; i += 1) {
                hex = parseInt(next(), 16);
                if (!isFinite(hex)) {
                  break;
                }
                uffff = uffff * 16 + hex;
              }
              string += String.fromCharCode(uffff);
            } else if (typeof escapee[ch] === 'string') {
              string += escapee[ch];
            } else {
              break;
            }
          } else {
            string += ch;
          }
        }
      }
      error('Bad string');
    },
    white = function white() {
      // Skip whitespace.

      while (ch && ch <= ' ') {
        next();
      }
    },
    word = function word() {
      // true, false, or null.

      switch (ch) {
        case 't':
          next('t');
          next('r');
          next('u');
          next('e');
          return true;
        case 'f':
          next('f');
          next('a');
          next('l');
          next('s');
          next('e');
          return false;
        case 'n':
          next('n');
          next('u');
          next('l');
          next('l');
          return null;
      }
      error("Unexpected '" + ch + "'");
    },
    value,
    // Place holder for the value function.

    array = function array() {
      // Parse an array value.

      var array = [];

      if (ch === '[') {
        next('[');
        white();
        if (ch === ']') {
          next(']');
          return array; // empty array
        }
        while (ch) {
          array.push(value());
          white();
          if (ch === ']') {
            next(']');
            return array;
          }
          next(',');
          white();
        }
      }
      error('Bad array');
    },
    object = function object() {
      // Parse an object value.

      var key,
        object = {};

      if (ch === '{') {
        next('{');
        white();
        if (ch === '}') {
          next('}');
          return object; // empty object
        }
        while (ch) {
          key = string();
          white();
          next(':');
          if (Object.hasOwnProperty.call(object, key)) {
            error('Duplicate key "' + key + '"');
          }
          object[key] = value();
          white();
          if (ch === '}') {
            next('}');
            return object;
          }
          next(',');
          white();
        }
      }
      error('Bad object');
    };

  value = function value() {
    // Parse a JSON value. It could be an object, an array, a string, a number,
    // or a word.

    white();
    switch (ch) {
      case '{':
        return object();
      case '[':
        return array();
      case '"':
        return string();
      case '-':
        return number();
      default:
        return ch >= '0' && ch <= '9' ? number() : word();
    }
  };

  // Return the json_parse function. It will have access to all of the above
  // functions and variables.

  return function (source, reviver) {
    var result;

    text = source;
    at = 0;
    ch = ' ';
    result = value();
    white();
    if (ch) {
      error('Syntax error');
    }

    // If there is a reviver function, we recursively walk the new structure,
    // passing each name/value pair to the reviver function for possible
    // transformation, starting with a temporary root object that holds the result
    // in an empty key. If there is not a reviver function, we simply return the
    // result.

    return typeof reviver === 'function'
      ? (function walk(holder, key) {
        var k,
          v,
          value = holder[key];
        if (
          value &&
          (typeof value === 'undefined'
            ? 'undefined'
            : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(
              value
            )) === 'object'
        ) {
          for (k in value) {
            if (Object.prototype.hasOwnProperty.call(value, k)) {
              v = walk(value, k);
              if (v !== undefined) {
                value[k] = v;
              } else {
                delete value[k];
              }
            }
          }
        }
        return reviver.call(holder, key, value);
      })({ '': result }, '')
      : result;
  };
})();

export default {
  hasEmoji,
  isFileSizeValid,
  fileCompress,
  isNetWork,
  compareSDKVersion,
  isImPage,
  keepOnlyOneIm,
  saveUserLocation,
  isIphoneFullScreen,
  BottomSaveAreaHeight,
  filterWxMessage,
  json_parse,
};
